import {isMobile} from "@/helpers/mobile-helper";

export function viewFit(geometry, padding = undefined, maxZoom = undefined, duration = 2000, calculatePadding = false) {

    if(calculatePadding) {

        //// console.log(calculatePadding)
        let paddingRight = 50
        let paddingLeft = 50
        let paddingTop = 50
        let paddingBottom = 50
        if(isMobile()) {

            let height = 0
            document.querySelectorAll('.info-menu-info-header').forEach(element => {
                if(element.offsetHeight > height) {
                    height = element.offsetHeight
                }
            })
            paddingTop = height + 50
            paddingBottom = 100
        } else {
            paddingRight = document.getElementsByClassName('info-menu-content')[0].offsetWidth + 80
            paddingLeft = document.getElementsByClassName('layer-menu')[0].offsetWidth + 20
        }
        padding = [paddingTop, paddingRight, paddingBottom, paddingLeft]
    }

    if(geometry !== undefined) {

        if(!maxZoom) {
            maxZoom = undefined
        }

        window.view.fit(geometry, {
            padding: padding,
            maxZoom: maxZoom,
            duration: duration
        });
    }
}

export function resetViewRotation() {
    window.view.setRotation(0)
}

export function getViewRotation() {
    return window.view.getRotation()
}

